var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbstractFigure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 234,
    viewBox: "0 0 183 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.558,
    y: 171.844,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.558,
    y: 110.21,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.4955,
    y: 171.844,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93.4955,
    y: 110.21,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 128.682,
    y: 34.2418,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    transform: "rotate(30 128.682 34.2418)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 147.867,
    y: 1.09961,
    width: 17.6779,
    height: 38.3707,
    rx: 3.65625,
    transform: "rotate(30 147.867 1.09961)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 147.68,
    y: 45.2106,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    transform: "rotate(30 147.68 45.2106)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 166.803,
    y: 11.9876,
    width: 17.6779,
    height: 38.4096,
    rx: 3.65625,
    transform: "rotate(30 166.803 11.9876)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1625,
    y: 53.3824,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    transform: "rotate(-28.8735 19.1625 53.3824)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.709608,
    y: 19.8271,
    width: 17.6779,
    height: 38.3707,
    rx: 3.65625,
    transform: "rotate(-28.8735 0.709608 19.8271)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3729,
    y: 42.7894,
    width: 17.7589,
    height: 61.6339,
    rx: 3.65625,
    transform: "rotate(-28.8735 38.3729 42.7894)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8183,
    y: 9.24582,
    width: 17.6779,
    height: 38.4096,
    rx: 3.65625,
    transform: "rotate(-28.8735 19.8183 9.24582)",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.897 110.21C102.723 106.031 102.897 96.525 104.987 91.9286",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4372 110.21C80.6114 106.031 80.4372 96.525 78.348 91.9286",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4375 101.33H102.897",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3928 94.0178H104.464",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.357 75.7366L128.491 77.8259",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2769 78.3482L56.9331 76.2589",
    stroke: "#E3E5E6",
    strokeWidth: 1.04464
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractFigure);
export default __webpack_public_path__ + "static/media/abstract-figure.109e5297c81339327846a1f5866080e9.svg";
export { ForwardRef as ReactComponent };